var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32051 5.19047C8.55639 5.56499 9.88477 5.01476 10.4938 3.87604C11.1374 2.67274 12.8626 2.67274 13.5062 3.87604C14.1152 5.01476 15.4436 5.56499 16.6795 5.19047C17.9855 4.79472 19.2053 6.01455 18.8095 7.32051C18.435 8.55639 18.9852 9.88477 20.124 10.4938C21.3273 11.1374 21.3273 12.8626 20.124 13.5062C18.9852 14.1152 18.435 15.4436 18.8095 16.6795C19.2053 17.9855 17.9855 19.2053 16.6795 18.8095C15.4436 18.435 14.1152 18.9852 13.5062 20.124C12.8626 21.3273 11.1374 21.3273 10.4938 20.124C9.88477 18.9852 8.55639 18.435 7.32051 18.8095C6.01455 19.2053 4.79472 17.9855 5.19047 16.6795C5.56499 15.4436 5.01476 14.1152 3.87604 13.5062C2.67274 12.8626 2.67274 11.1374 3.87604 10.4938C5.01476 9.88477 5.56499 8.55639 5.19047 7.32051C4.79472 6.01455 6.01455 4.79472 7.32051 5.19047Z",
    fill: "#29BAF9",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10L11 13.6667L9.33337 12",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedMark);
export default __webpack_public_path__ + "static/media/checked-mark.002a8cea8655e2488125a9486bf876c4.svg";
export { ForwardRef as ReactComponent };